module.exports = __webpack_public_path__ + "static/cathay-566a50295ef74522e305ae1d43df8cfc.jpg";